import React, { useContext, useEffect, useState } from 'react';
import { apiGet } from '../../utils/apiFetch';
import apiPath from '../../utils/apiPath';
import SubTable from './SubTable';
import SubEdit from './SubEdit';
import SubAdd from './SubAdd';
import Pagination from '../Pagination';
import dayjs from 'dayjs';
import SubAdminView from './SubAdminView';
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker';
import { useTranslation } from 'react-i18next';
import AuthContext from 'context/AuthContext';
import SubadminResetPassword from './SubadminResetPassword';

function SubAdmin() {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const manager =
    user?.permission?.find((e) => e.manager === 'sub_admin_manager') ?? {};
  const [showModal, setShowModal] = useState(false);
  const [editShowModal, setEditShowModal] = useState(false);
  const [viewShow, setViewShow] = useState(false);
  const [subAdmin, setSubAdmin] = useState([]);
  const [resetPasswordShow, setResetPasswordShow] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [item, setItem] = useState('');
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [filterData, setFilterData] = useState({
    category: '',
    searchKey: '',
    startDate: '',
    endDate: '',
    isReset: false,
  });
  const [sort, setSort] = useState({
    sort_key: 'createdAt',
    sort_type: 'desc',
  });

  const allSubAdmin = async (data) => {
    try {
      const { category, startDate, endDate, searchKey, isFilter } = filterData;

      if (
        (data?.deletePage && !(subAdmin?.length > 1)) ||
        (isFilter && category && data?.statusChange && !(subAdmin?.length > 1))
      ) {
        setPage(page - 1);

        setPaginationObj({ ...paginationObj, page: page - 1 });
      }

      const payload = {
        page,
        page_size: pageSize,
        status: category,
        start_date: startDate ? dayjs(startDate).format('YYYY-MM-DD') : null,
        end_date: endDate ? dayjs(endDate).format('YYYY-MM-DD') : null,
        keyword: searchKey,
        sort_key: sort.sort_key,
        sort_type: sort.sort_type,
      };

      const path = apiPath.getSubAdmin;
      const result = await apiGet(path, payload);
      const response = result?.data?.results;
      const resultStatus = result?.data?.success;
      setSubAdmin(response?.docs);
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null,
      });
      // }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message);
    }
  };
  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };
  const handelEdit = (newItem) => {
    console.log(newItem)
    setItem(newItem);
    setEditShowModal(true);
  };

  const handleUserView = (newItem) => {
    setItem(newItem);
    setViewShow(true);
  };

  const handleResetPassword = (newItem) => {
    setItem(newItem);
    setResetPasswordShow(true);
  };

  useEffect(() => {
    allSubAdmin();
  }, [filterData, page, sort]);

  const handleChangeData = (e) => {
    setFilterData({ ...filterData, searchKey: e.target.value, isFilter: true });
    setPage(1);
  };

  const handleReset = () => {
    setFilterData({
      category: '',
      searchKey: '',
      startDate: '',
      endDate: '',
      isReset: true,
      isFilter: false,
    });
    setPage(1);
  };

  const handleDateChange = (start, end) => {
    // setStartDate(start)
    setPage(1);
    // setEndDate(end)
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true,
    });
  };
  const statusPage = (e) => {
    // setCategory(e.target.value)
    setPage(1);
    setFilterData({ ...filterData, category: e.target.value, isFilter: true });
  };
  return (
    <div>
      <div className="bg-white">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9] ">
            {/* filter section */}
            <form className="border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3 flex-wrap justify-between">
              <div className="col-span-2 flex flex-wrap  items-center">
                <div className="flex items-center lg:pt-0 pt-3 flex-wrap justify-center mb-2 2xl:mb-0">
                  {/* <div className='flex items-center mb-3 sm:mb-0'>
                    <label className='mx-2 text-[#B8BBBF] text-xs'>From</label>
                    <DatePicker
                      className='flex flex-row-reverse border border-[#E9EDF9] text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full  p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                      value={startDate}
                      onChange={(e) => setStartDate(e)}
                      maxDate={endDate}
                      format='dd-MM-yyyy'
                      clearIcon=''
                      yearPlaceholder='yy'
                      dayPlaceholder='dd'
                      monthPlaceholder='mm'
                    />

                  </div>
                  <div className='flex items-center  mb-3 sm:mb-0'>
                    <label className='mx-2 text-[#B8BBBF] text-xs'>To</label>
                    <DatePicker
                      className='flex flex-row-reverse border border-[#E9EDF9] text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full  p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                      value={endDate}
                      onChange={(e) => setEndDate(e)}
                      minDate={startDate}
                      format='dd-MM-yyyy'
                      clearIcon=''
                      yearPlaceholder='yy'
                      dayPlaceholder='dd'
                      monthPlaceholder='mm'
                    />
                  </div> */}
                  <ODateRangePicker
                    handleDateChange={handleDateChange}
                    isReset={filterData?.isReset}
                    setIsReset={setFilterData}
                  />
                  <div className="flex items-center  ml-3 mb-3">
                    <select
                      id=""
                      type="text "
                      name="category"
                      className="block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                      placeholder=" "
                      onChange={(e) => statusPage(e)}
                      value={filterData?.category}
                    >
                      <option defaultValue value="">
                        {t('O_ALL')}
                      </option>
                      <option value="active">{t('O_ACTIVE')}</option>
                      <option value="inactive">{t('O_INACTIVE')}</option>
                    </select>
                  </div>

                  {/* <OButton
                    label={{t(O_RESET)}}
                    type='button'
                    onClick={handleReset}
                    extraClasses='ml-3'
                    style={{ borderRadius: '0.5rem' }}
                  /> */}
                  <button
                    type="button"
                    onClick={handleReset}
                    className="bg-[#8FC150] text-sm px-8 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto w-1/2"
                  >
                    {t('O_RESET')}
                  </button>

                  {/* <button
                    type='button'
                    onClick={handleReset}
                    className='bg-[#8FC150] text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto w-1/2'
                  >
                    Reset
                  </button> */}
                </div>
              </div>

              <div className="lg:pt-0 pt-2">
                <label
                  htmlFor="default-search"
                  className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
                >
                  {t('O_SEARCH')}
                </label>
                <div className="flex min-w-[203px]">
                  <div className="relative ">
                    <div className="absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none">
                      <svg
                        aria-hidden="true"
                        className="w-4 h-4 text-[#A5A5A5] dark:text-gray-40"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        {!filterData?.searchKey && (
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          />
                        )}
                      </svg>
                    </div>
                    <input
                      type="search"
                      id="default-search"
                      title=""
                      className="block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[300px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder={t(
                        'SUB_ADMIN_SEARCH_BY_USER_NAME_EMAIL_MOBILE'
                      )}
                      value={filterData?.searchKey}
                      required
                      onChange={(e) => handleChangeData(e)}
                    />
                  </div>
                  {(manager?.add || user?.role === 'admin') && (
                    <button
                      title={t('SUB_ADMIN_ADD_SUB_ADMIN')}
                      type="button"
                      className="bg-[#8FC150] flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] whitespace-nowrap"
                      onClick={() => setShowModal(true)}
                    >
                      + {t('SUB_ADMIN_ADD_SUB_ADMIN')}
                    </button>
                  )}
                </div>
              </div>
            </form>
            <SubTable
              subAdmin={subAdmin}
              handelEdit={handelEdit}
              allSubAdmin={allSubAdmin}
              handleUserView={handleUserView}
              handleResetPassword={handleResetPassword}
              page={page}
              setSort={setSort}
              sort={sort}
              manager={manager}
              paginationObj={paginationObj}
            />
            {paginationObj?.totalItems !== 0 && (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />
            )}
          </div>
        </div>
      </div>

      <>
        {showModal && (
          <SubAdd setShowModal={setShowModal} allSubAdmin={allSubAdmin} />
        )}
        {editShowModal && (
          <SubEdit
            setEditShowModal={setEditShowModal}
            allSubAdmin={allSubAdmin}
            item={item}
          />
        )}
        {viewShow && <SubAdminView setViewShow={setViewShow} item={item} />}
        {resetPasswordShow && (
          <SubadminResetPassword
            item={item}
            setResetPasswordShow={setResetPasswordShow}
          />
        )}
      </>
    </div>
  );
}

export default SubAdmin;
